export default __webpack_public_path__ + "img/InterDisplay-Thin_604f013.woff2";